import React from "react";
import { Typography, TableHead, TableRow, TableCell } from "@mui/material";
import { useTranslation } from "react-i18next";

const OverlappingAbsencesTableHeader = () => {
  const { t } = useTranslation();
  const tRP = "components.my_leaves";
  const translationFields = `${tRP}.fields`;

  return (
    <>
      <TableHead>
        <TableRow>
          <TableCell align={"center"}></TableCell>

          <TableCell align={"center"}>
            <Typography>{`${t(`${translationFields}.employee`)}`}</Typography>
          </TableCell>

          <TableCell align={"center"}>
            <Typography>{`${t(`${translationFields}.absence_type`)}`}</Typography>
          </TableCell>

          <TableCell align={"center"}>
            <Typography>{`${t(`${translationFields}.from_date`)}`}</Typography>
          </TableCell>

          <TableCell align={"center"}>
            <Typography>{`${t(`${translationFields}.to_date`)}`}</Typography>
          </TableCell>

          <TableCell align={"center"}>
            <Typography>{`${t(`common_words.document`)}`}</Typography>
          </TableCell>

          <TableCell align={"center"}>
            <Typography>{`${t(`${translationFields}.is_approved_rejected`)}`}</Typography>
          </TableCell>

          <TableCell align={"center"}>
            <Typography>{`${t(`${translationFields}.accepted_rejected_by_client`)}`}</Typography>
          </TableCell>
        </TableRow>
      </TableHead>
    </>
  );
};

export default React.memo(OverlappingAbsencesTableHeader);
